import Vue from "vue";

export default {
  setUserToken: (state, value) => {
    state.userToken = value;
  },
  setUserRoles: (state, value) => {
    const { level, tester } = value;
    state.userRoles = level;
    state.isTester = tester;
    localStorage.userRoles = JSON.stringify(value);
  },
  setRejectReasons: (state, value) => {
    state.rejectReasons = value;
  },
  setDeclineReasons: (state, value) => {
    state.declineReasons = value;
  },
  setReclaimReasons: (state, value) => {
    state.reclaimReasons = value;
  },
  setLocations: (state, value) => {
    state.locations = value;
  },
  resetUserToken: state => {
    state.userToken = "";
  },
  setSelectedReceiptId: (state, value) => {
    state.selectedReceptId = value;
  },
  setDialogOpen: (state, value) => {
    state.dialogOpen = value;
  },
  setLevel: (state, value) => {
    state.level = value;
  },
  setFieldValue: (state, { field, value }) => {
    Vue.set(state.currentReceipt, field, value);
  },
  clearCurrentReceipt: state => {
    state.currentReceipt.selectedProducts = [];
    state.currentReceipt.receiptImageURL = "";
    state.currentReceipt.createdAt = "";
    state.currentReceipt.createdAtDate = "";
    state.currentReceipt.createdAtTime = "";
    state.currentReceipt.id = "";
    state.currentReceipt.status = "";
    state.currentReceipt.sendSftp = "";
    state.currentReceipt.receiptId = "";
    state.currentReceipt.vatNumber = "",
    state.currentReceipt.total = "";
    state.currentReceipt.reClaimed = 0;
    state.currentReceipt.campaignTitle = "";
    state.currentReceipt.rejectReason = "";
    state.currentReceipt.receiptNumber = "";
    state.currentReceipt.campaign_fk = "";
    state.currentReceipt.productImageURL = "";
    state.currentReceipt.retailerFk = "";
    state.currentReceipt.paymentAmount = 0;
    state.currentReceipt.hasWallet = false;
    state.currentReceipt.productTotal = 0;
    state.currentReceipt.products = [];
    state.currentReceipt.processedProducts = [];
    state.currentReceipt.selectedCheckbox = {
      vatMetro: { value: false, status: 0 },
      rossmannDiscount: { value: false, status: 0 }
    };
    state.currentReceipt.couponsToCreate = 1;
    state.currentReceipt.hasEditableCoupons = false;
    state.currentReceipt.detailsText = "";
    state.currentReceipt.campaignStartDate = "";
    state.currentReceipt.campaignEndDate = "";
    state.currentReceipt.location = "";
    state.currentReceipt.customerToken = "";
    state.currentReceipt.receiptDateTime = "";
    state.currentReceipt.campaignRetailers = [];
    state.currentReceipt.prevReceipts = [];
    state.currentReceipt.usedReceipts = [];
    state.currentReceipt.fraud = false;
    state.currentReceipt.productImageURL = [];
    state.currentReceipt.viewedProduct = [];
    state.currentReceipt.productImageLength = 0;
    state.currentReceipt.paymentHistory = {};
    state.currentReceipt.fraudResult = "";
    state.currentReceipt.processHistory = [];
    state.currentReceipt.paymentStatus = "";
    state.currentReceipt.clubCode = "";
    state.currentReceipt.fiscalId = null;
    state.currentReceipt.rppData = [];
  },
  setCurrentReceipt: (state, value) => {
    state.currentReceipt = value;
  },
  setFraudResult: (state, payload) => {
    state.currentReceipt.fraudResult = payload;
  },
  setProcessHistory: (state, payload) => {
    state.currentReceipt.processHistory = payload;
  },
  setCampaign: (state, payload) => {
    state.campaign = payload;
  },
  setViewedProduct: (state, payload) => {
    state.viewedProduct = payload;
  },
  setReuploadLink: (state, payload) => {
    state.reuploadLink = payload;
  },
  setPayoutLink: (state, payload) => {
    state.payoutLink = payload;
  },
  setDashboarder: (state, payload) => {
    state.dashboarder = payload;
  },
  setFraudRiskScore: (state, payload) => {
    state.fraudRiskScore = payload;
  },
  setFraudModelScore: (state, payload) => {
    state.fraudModelScore = payload;
  },
  setFraudModelWeights: (state, payload) => {
    state.fraudModelWeights = payload;
  },
  setDashboardersList: (state, data) => {
    state.dashboardersList = data;
  },
  setSelectedRejectReason: (state, data) => {
    state.selectedRejectReason = data;
  },
  setCampaignsList: (state, data) => {
    state.campaignsList = data;
  },
  setDashboarderStats: (state, data) => {
    state.dashboarderStats = data;
  },
  setIsTester: (state, data) => {
    state.isTester = data;
  },
  snackBar: (state, payload) => {
    state.snackBar = payload;
    state.showSnackBar = true;
  },
  setSnackBarShow: (state, value) => {
    state.showSnackBar = value;
  },
  setDarkMode: (state, value) => {
    state.settings.isDark = value;
  },
  setDashboard: (state, value) => {
    localStorage.selectedDashboard = JSON.stringify(value);

    state.selectedDashboard = value;
  },
  setReceiptPendingStatus: (state, value) =>
    (state.currentReceipt.isPending = value),
  setPreviewProgress: (state, value)=>{
    state.previewProgress = value
  },
  setAutoPilotMode: (state, value) => {
    state.autoPilotMode = value;
  },
  setReceiptImageFile: (state, value) => {
    state.receiptImageFile = value;
  }
};
